(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
var swiper = new Swiper('.swiper-container', {
slidesPerView: 1.1,
spaceBetween: 8,
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
breakpoints: {
    500: {
      slidesPerView: 2.2,
      spaceBetween: 16
    },
    686: {
      slidesPerView: 2.5,
      spaceBetween: 16
    },
    720: {
      slidesPerView: 2.8,
      spaceBetween: 16
    },
    800: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    940: {
      slidesPerView: 3.5,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    993: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1100: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1300: {
      slidesPerView: 3.6,
      spaceBetween: 24
    },
    1440: {
      slidesPerView: 4.3,
      spaceBetween: 24
    },
    1650: {
      spaceBetween: 16,
      slidesPerView: 5.6
},
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-kennisbank"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
var swiper = new Swiper('.swiper-container', {
slidesPerView: 1.1,
spaceBetween: 8,
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
breakpoints: {
    500: {
      slidesPerView: 2.2,
      spaceBetween: 16
    },
    686: {
      slidesPerView: 2.5,
      spaceBetween: 16
    },
    720: {
      slidesPerView: 2.8,
      spaceBetween: 16
    },
    800: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    940: {
      slidesPerView: 3.5,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    993: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1100: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1300: {
      slidesPerView: 3.6,
      spaceBetween: 24
    },
    1440: {
      slidesPerView: 4.3,
      spaceBetween: 24
    },
    1650: {
      spaceBetween: 16,
      slidesPerView: 5.6
},
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article-recipe"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
var swiper = new Swiper('.swiper-container', {
slidesPerView: 1.1,
spaceBetween: 8,
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
breakpoints: {
    500: {
      slidesPerView: 2.2,
      spaceBetween: 16
    },
    686: {
      slidesPerView: 2.5,
      spaceBetween: 16
    },
    720: {
      slidesPerView: 2.8,
      spaceBetween: 16
    },
    800: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    940: {
      slidesPerView: 3.5,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    993: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1100: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1300: {
      slidesPerView: 3.6,
      spaceBetween: 24
    },
    1440: {
      slidesPerView: 4.3,
      spaceBetween: 24
    },
    1650: {
      spaceBetween: 16,
      slidesPerView: 5.6
},
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
var swiper = new Swiper('.swiper-container', {
slidesPerView: 1.1,
spaceBetween: 8,
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
breakpoints: {
    500: {
      slidesPerView: 2.2,
      spaceBetween: 16
    },
    686: {
      slidesPerView: 2.5,
      spaceBetween: 16
    },
    720: {
      slidesPerView: 2.8,
      spaceBetween: 16
    },
    800: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    940: {
      slidesPerView: 3.5,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    993: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1100: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1300: {
      slidesPerView: 3.6,
      spaceBetween: 24
    },
    1440: {
      slidesPerView: 4.3,
      spaceBetween: 24
    },
    1650: {
      spaceBetween: 16,
      slidesPerView: 5.6
},
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cadeaupagina"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
var swiper = new Swiper('.swiper-container-top10', {
slidesPerView: 1.1,
spaceBetween: 16,
navigation: {
nextEl: '.swiper-button-next',
prevEl: '.swiper-button-prev',
},
breakpoints: {
    500: {
      slidesPerView: 2.2,
      spaceBetween: 16
    },
    686: {
      slidesPerView: 2.5,
      spaceBetween: 16
    },
    720: {
      slidesPerView: 2.8,
      spaceBetween: 16
    },
    800: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    940: {
      slidesPerView: 3.5,
      spaceBetween: 16
    },
    992: {
      slidesPerView: 3.2,
      spaceBetween: 16
    },
    993: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1100: {
      slidesPerView: 3.2,
      spaceBetween: 24
    },
    1300: {
      slidesPerView: 3.6,
      spaceBetween: 24
    },
    1440: {
      slidesPerView: 4.3,
      spaceBetween: 24
    },
    1650: {
      spaceBetween: 16,
      slidesPerView: 5.6
},
}
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
window.initCartRecommendationsSwiper = function (root) {
  if (!root || typeof Swiper === 'undefined') return;

  var container = root.querySelector('.swiper-container');
  if (!container) return;

  if (container.swiper) {
    container.swiper.destroy(true, true);
  }

  new Swiper(container, {
    slidesPerView: 1.1,
    spaceBetween: 8,
    navigation: {
      nextEl: root.querySelector('.swiper-button-next'),
      prevEl: root.querySelector('.swiper-button-prev')
    },
    breakpoints: {
      500: {
        slidesPerView: 2.2,
        spaceBetween: 16
      },
      686: {
        slidesPerView: 2.5,
        spaceBetween: 16
      },
      720: {
        slidesPerView: 2.8,
        spaceBetween: 16
      },
      800: {
        slidesPerView: 3.2,
        spaceBetween: 16
      },
      940: {
        slidesPerView: 3.5,
        spaceBetween: 16
      },
      992: {
        slidesPerView: 3.2,
        spaceBetween: 16
      },
      993: {
        slidesPerView: 3.2,
        spaceBetween: 24
      },
      1100: {
        slidesPerView: 3.2,
        spaceBetween: 24
      },
      1300: {
        slidesPerView: 3.6,
        spaceBetween: 24
      },
      1440: {
        slidesPerView: 4.3,
        spaceBetween: 24
      },
      1650: {
        spaceBetween: 16,
        slidesPerView: 5.6
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', function () {
  window.initCartRecommendationsSwiper(document.querySelector('[data-cart-recommendations]'));
});

  } catch(e) { console.error(e); }
})();
})();
